import { Box, Typography } from "@mui/material";
import LinearProgress, {
	linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 10,
	borderRadius: 5,
	backgroundColor:
		theme.palette.mode === "dark"
			? theme.palette.grey[800]
			: theme.palette.grey[200],
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: theme.palette.mode === "dark" ? "#308fe8" : "#1a90ff",
	},
}));

const ProgressBar = ({ value }) => {
	return (
		<Box sx={{ display: "flex", alignItems: "center" }}>
			<Box sx={{ width: "100%", mr: 1 }}>
				<BorderLinearProgress variant="determinate" value={value} />
			</Box>
			<Box sx={{ minWidth: 35 }}>
				<Typography variant="body2" sx={{ color: "text.secondary" }}>
					{`${Math.round(value)}%`}
				</Typography>
			</Box>
		</Box>
	);
};

export default ProgressBar;
